<template>
  <list-page-layout class="lease-list-page" :pageSize="pageSize" :currentPage="currentPage" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">发货单列表</span>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="发货单号" prop="Code">
        <el-input v-model="searchForm.Code" placeholder="请输入发货单号" @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="客户名称" prop="PartnerName">
        <el-input v-model="searchForm.PartnerName" placeholder="请输入客户名称" @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="订单来源" prop="OriginalOrderCode">
        <el-input v-model="searchForm.OriginalOrderCode" placeholder="请输入订单来源号" @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="时间段" prop="OrderDateDuration">
        <el-date-picker
          v-model="searchForm.OrderDateDuration"
          type="daterange"
          align="right"
          placeholder="选择日期范围">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="IsLoading" style="width: 130px" @click="handleSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div  class="tab" slot="main-content">
      <el-tabs  :value="currentTab" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="待发货" name="reserved"></el-tab-pane>
        <el-tab-pane label="已发货" name="shipped"></el-tab-pane>
        <el-tab-pane label="已完成" name="finished"></el-tab-pane>
      </el-tabs>
    <complex-grid v-loading="IsLoading" element-loading-text="加载中" :config="tableConfig" :data="tableData">
      <template slot="sub-header" scope="props">
        <el-col :span="4" style="min-width: 136px">{{props.row.OrderDate | date('YYYY-MM-DD HH:mm:ss')}}</el-col>
        <el-col :span="4">发货单：{{props.row.Code}}</el-col>
        <el-col :span="6">
          <span>订单来源：{{props.row.OriginalOrderType | LogisticsSource}}<span v-if="props.row.OriginalOrderType === 'RentalOrder'">（{{props.row.OriginalOrderCode}}）</span></span>
        </el-col>
        <el-col :span="3">发货类型：{{props.row.ShipmentMethod | ShipmentMethod}}</el-col>
        <el-col :span="5" v-if="props.row.Partner">客户名称：{{props.row.Partner.Name}}</el-col>
        <el-col :span="4" class="text-right">状态：<span style="color: red">{{props.row.State | StockTransferState}}</span></el-col>
      </template>
      <template slot="Lot" scope="props">
        <span>{{props.row.Lot.Code}}</span>
      </template>
      <template slot="ProductName" scope="props">
        <p style="margin: 4px 0">{{props.row.Lot.Product.Name}}</p>
        <p style="margin: 4px 0">物料编码：{{props.row.Lot.Product.Code}}</p>
      </template>
      <template slot="ProductConditionName" scope="props">
        <el-tag :type="props.row.Lot.Condition.Name | ConditionColor">{{props.row.Lot.Condition.Name}}</el-tag>
      </template>
      <template slot="Brand" scope="props">
        {{props.row.Lot.Product.Brand.Name}}
      </template>
      <template slot="Model" scope="props">
        {{props.row.Lot.Product.Model.Name}}
      </template>
      <template slot="Module" scope="props">
        {{props.row.Lot.Product.Module.Name}}
      </template>
      <template slot="Location" scope="props">
        <span v-if="props.row.Lot.CurrentLocationCode">{{props.row.Lot.CurrentLocationName}}</span>
      </template>
      <template slot="action-bar" scope="props">
        <el-popover
          ref="popover"
          placement="left"
          width="500"
          trigger="click">
          <el-table :data="ThirdPartyDeliveryInfo" :max-height="300">
            <el-table-column width="180" property="time" label="时间"></el-table-column>
            <el-table-column width="320" property="context" label="物流信息"></el-table-column>
          </el-table>
        </el-popover>
        <el-button  v-if="props.row.ShipmentMethod === 'external'" type="text" v-popover:popover @click="handleGetThirdPartyDeliveryInfo(props.row.Id)">查看快递信息</el-button>
      </template>
    </complex-grid>
   </div>
  </list-page-layout>
</template>

<script>
import ListPageLayout from '@/components/common/ListPageLayout'
import ComplexGrid from '@/components/common/ComplexGrid'
import o from '@/odata'
export default {
  data() {
    return {
      searchForm: {
        Code: null,
        PartnerName: null,
        OriginalOrderCode: null,
        OrderDateDuration: null,
      },
      SentDialog: {
        Id: null,
        show: false,
        list: [],
        type: null,
        ShipToPointOfSales: null,
        FormData: {},
      },
      IsLoading: false,
      ThirdPartyDeliveryInfo: [
        // { 'time': '2012-07-07 13:35:14', 'context': '客户已签收' },
        // { 'time': '2012-07-07 09:10:10', 'context': '离开[北京石景山营业厅]派送中，递送员[温]，电话[]' },
        // { 'time': '2012-07-06 19:46:38', 'context': '到达[北京石景山营业厅]' },
        // { 'time': '2012-07-06 15:22:32', 'context': '离开[北京石景山营业厅]派送中，递送员[温]，电话[]' },
        // { 'time': '2012-07-06 15:05:00', 'context': '到达[北京石景山营业厅]' },
        // { 'time': '2012-07-06 13:37:52', 'context': '离开[北京_同城中转站]发往[北京石景山营业厅]' },
        // { 'time': '2012-07-06 12:54:41', 'context': '到达[北京_同城中转站]' },
        // { 'time': '2012-07-06 11:11:03', 'context': '离开[北京运转中心驻站班组] 发往[北京_同城中转站]' },
        // { 'time': '2012-07-06 10:43:21', 'context': '到达[北京运转中心驻站班组]' },
        // { 'time': '2012-07-05 21:18:53', 'context': '离开[福建_厦门支公司] 发往 [北京运转中心_航空]' },
        // { 'time': '2012-07-05 20:07:27', 'context': '已取件，到达 [福建_厦门支公司]' },
      ],
      currentTab: 'all',
      currentPage: 1,
      tableConfig: {
        dataPrefix: 'Transfers',
        column: [
          {
            label: '批次号',
            width: '190px',
            slot: 'Lot',
          },
          {
            label: '物料名称',
            slot: 'ProductName',
            width: '260px',
          },
          {
            label: '品项',
            slot: 'ProductConditionName',
          },
          {
            label: '品牌',
            slot: 'Brand',
          },
          {
            label: '机型',
            slot: 'Model',
          },
          {
            label: '模块',
            slot: 'Module',
          },
          {
            label: '库位',
            slot: 'Location',
          },
          {
            label: '操作',
            collapse: true,
            key: 'action-bar',
            class: 'text-center',
            width: '140px',
          },
        ],
      },
      tableData: [],
      loading: false,
      pageSize: 10,
      total: 0,
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    handleChange(params) {
      this.currentPage = params
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    handleSearch() {
      this.IsLoading = true
      const Query = o('OutStockPicking')
      let filters = []
      if (this.searchForm.Code) {
        filters.push(`contains(Code, '${this.searchForm.Code}')`)
      }
      if (this.searchForm.PartnerName) {
        filters.push(`contains(Partner/Name, '${this.searchForm.PartnerName}')`)
      }
      if (this.searchForm.ShipmentMethod) {
        filters.push(`contains(ShipmentMethod, '${this.searchForm.ShipmentMethod}')`)
      }
      if (this.searchForm.OriginalOrderCode) {
        filters.push(`contains(OriginalOrderCode, '${this.searchForm.OriginalOrderCode}')`)
      }
      if (this.searchForm.OrderDateDuration) {
        const startDate = this.$moment(this.searchForm.OrderDateDuration[0]).utc().add(1, 'd').set({hour: 0, minute: 0, second: 0}).format()
        const endDate = this.$moment(this.searchForm.OrderDateDuration[1]).utc().add(2, 'd').set({hour: 0, minute: 0, second: 0}).add(-1, 's').format()
        filters.push(`(OrderDate ge ${startDate} and OrderDate le ${endDate})`)
      }
      if (this.currentTab !== 'all') {
        filters.push(`contains(State, '${this.currentTab}')`)
      }
      if (filters.length > 0) {
        Query.filter(filters.join(' and '))
      }
      Query.expand('Partner($select=Id,Code,Name)')
      Query.expand('RentalOrder($select=Id,Code)')
      Query.expand('ExpressCompany($select=Name)')
      Query.expand('Transfers($expand=Lot)')
      Query.expand('BackupTransfers($expand=Condition,Product)')
      Query.inlineCount()
      Query.skip((this.currentPage - 1) * this.pageSize)
      Query.top(this.pageSize)
      Query.orderBy('OrderDate', 'desc')
      Query.get().then(({data, inlinecount}) => {
        data.forEach(currentItem => {
          // console.log(currentItem)
          currentItem.Lines = [...currentItem.Transfers.map(item => item.Lot), ...currentItem.BackupTransfers.map(item => {
            item.Product.Name += '(备用件)'
            return item
          })]
        })
        this.tableData = data
        this.total = inlinecount
      }).finally(() => {
        this.IsLoading = false
      })
    },
    handleGetThirdPartyDeliveryInfo(id) {
      o(`OutStockPicking(${id})/Services.GetThirdPartyDeliveryInfo()`).get()
      .then(({ data }) => {
        this.ThirdPartyDeliveryInfo = data.data
      })
    },
    handleTabClick({name}) {
      this.currentTab = name
      this.handleSearch()
    },
    // handleSizeChange(pageSize) {
    //   this.pageSize = pageSize
    //   this.handleSearch()
    // },
    // handleCurrentChange(page) {
    //   this.currentPage = page
    //   this.handleSearch()
    // },
  },
  components: {
    ListPageLayout,
    ComplexGrid,
  },
}
</script>




// WEBPACK FOOTER //
// LeaseSendListPage.vue?5562b533